import { Tooltip } from 'antd';
import { CaretRightOutlined, MutedOutlined, PauseOutlined, SoundOutlined } from '@ant-design/icons';

import { Button, Select } from '../../../../components/ui';
import { useT } from '../../../../i18n';
import type { Giong } from '../../hooks/useChung';

/**
 * Ô chọn giọng đọc + công tắc bật/tắt đọc thành tiếng. Giọng là thứ đổi MỘT LẦN rồi giữ mãi — nhưng lần ấy phải làm
 * được (ba giọng vùng). Danh sách lấy từ máy chủ nên GIỐNG NHAU trên mọi máy.
 */
export function ChonGiong({
  danhSach, giong, onDoiGiong, bat, onBat, dangDoc, dangTam, onTam,
}: {
  danhSach: Giong[];
  giong: string | null;
  onDoiGiong: (v: string) => void;
  bat: boolean;
  onBat: (v: boolean) => void;
  dangDoc: boolean;
  dangTam: boolean;
  onTam: () => void;
}) {
  const { t } = useT();
  // Máy chủ chưa nạp giọng nào: MỘT icon mờ, không hiện ô chọn rỗng — ô không có mục nào dạy rằng bấm vào không có gì.
  if (!danhSach.length) {
    return (
      <Tooltip title={`${t('troLyAiHoiGiong.chuaCoGiong')} ${t('troLyAiHoiGiong.chuaCoGiongMo')}`}>
        <span
          role="img"
          className="flex size-8 items-center justify-center text-content-muted"
          aria-label={t('troLyAiHoiGiong.chuaCoGiong')}
        >
          <MutedOutlined />
        </span>
      </Tooltip>
    );
  }

  return (
    <div className="flex items-center gap-1">
      {/* TẠM DỪNG TÁCH KHỎI TẮT: một nút làm cả hai thì người muốn ngắt một lát rồi nghe tiếp không có đường nào —
          bật lại là đọc lại từ đầu. Nút này chỉ hiện khi có tiếng để dừng. */}
      {dangDoc || dangTam ? (
        <Tooltip title={dangTam ? t('troLyAiHoiGiong.tiepTuc') : t('troLyAiHoiGiong.tamDung')}>
          <Button
            size="sm"
            shape="circle"
            variant="primary"
            aria-label={dangTam ? t('troLyAiHoiGiong.tiepTuc') : t('troLyAiHoiGiong.tamDung')}
            className={dangDoc && !dangTam ? 'motion-safe:animate-pulse' : ''}
            icon={dangTam ? <CaretRightOutlined /> : <PauseOutlined />}
            onClick={onTam}
          />
        </Tooltip>
      ) : null}

      {/* Icon đổi hẳn (loa / loa gạch) chứ không chỉ đổi màu: màu một mình không phân biệt được với người mù màu. */}
      <Tooltip title={bat ? t('troLyAiHoiGiong.tatDoc') : t('troLyAiHoiGiong.batDoc')}>
        <Button
          size="sm"
          shape="circle"
          variant={bat ? 'secondary' : 'ghost'}
          aria-label={bat ? t('troLyAiHoiGiong.tatDoc') : t('troLyAiHoiGiong.batDoc')}
          aria-pressed={bat}
          icon={bat ? <SoundOutlined /> : <MutedOutlined />}
          onClick={() => onBat(!bat)}
        />
      </Tooltip>

      {bat ? (
        <Select<string>
          aria-label={t('troLyAiHoiGiong.giongDoc')}
          size="small"
          className="w-[168px]"
          value={giong ?? undefined}
          onChange={(v) => onDoiGiong(v)}
          options={danhSach.map((g) => ({ value: g.ma, label: g.nhan }))}
        />
      ) : null}
    </div>
  );
}
